<template>
  <el-select
    :value="value"
    filterable
    remote
    :remote-method="search"
    :loading="isSearching"
    :placeholder="$t(`${I18N}.placeholder`)"
    :aria-label="$t(`${I18N}.label`)"
    size="small"
    class="mapping-analysis-select"
    @change="select"
  >
    <!-- Element's custom option template: one line, the code decides. -->
    <el-option
      v-for="option in options"
      :key="option.id"
      :value="option.id"
      :label="`${option.code} - ${option.description}`"
    >
      <span>{{ option.code }}</span>
      <span class="mapping-analysis-select__description">
        {{ option.description }}
      </span>
    </el-option>
  </el-select>
</template>

<script>
  import remoteOptionsMixin from './remoteOptionsMixin';
  import { searchAnalyses } from './analysisSearch';

  // The analysis of a mapping, searched by code or description among the
  // analyses of the user's laboratories (`GET /analyses`, not the stability
  // client: C12).
  export default {
    name: 'MappingAnalysisSelect',
    mixins: [remoteOptionsMixin],
    props: {
      value: { type: Number, default: null },
      // The selected analysis, so its label shows before any search.
      analysis: { type: Object, default: null },
    },
    data() {
      return {
        I18N: 'analysesData.importValues.columns.analysis',
      };
    },
    computed: {
      selectedOption() {
        return this.analysis;
      },
    },
    methods: {
      // By code or description; an empty query would match every analysis.
      async fetchOptions(query) {
        return { data: query ? await searchAnalyses(query) : [] };
      },
      select(id) {
        this.$emit('change', { analysisId: id, analysis: this.findOption(id) });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .mapping-analysis-select {
    width: 100%;
  }

  .mapping-analysis-select__description {
    float: right;
    margin-left: 1rem;
    color: $--color-text-regular;
  }
</style>
